export default __webpack_public_path__ + "static/media/3d-speech-bubble.eed55adf.png";